import React, { Component } from 'react';
import LovUserNav from './LovUserNav.js';
import LovAdminNav from './LovAdminNav.js';
import ASMUserNav from './ASMUserNav.js';
import ASMAdminNav from './ASMAdminNav.js';

export default class Nav extends Component{
	constructor(props){
		super(props);
		this.buttonClick = this.buttonClick.bind(this);
	}

	buttonClick(navAway,navTo){ //pass down method for handling navigation
		this.props.onChange(this.props.navState,navAway,navTo);
	}

	render(){
		const type = this.props.user;
		const app = this.props.app;
		let navbar;
		if (app === "lov"){ //determine which navbar to display depending on which app was chosen and user type
			if(type === "admin" || type === "sys_admin"){
				navbar = <LovAdminNav user={type} navClick={this.buttonClick} logout={this.props.logout}/>;
			}else{
				navbar = <LovUserNav user={type} navClick={this.buttonClick} logout={this.props.logout}/>;
			}
		}else{
			if(type === "asm_admin" || type === "sys_admin"){
				navbar = <ASMAdminNav user={type} navClick={this.buttonClick} logout={this.props.logout} leaveShop={this.props.leaveShop}/>;
			}else{
				navbar = <ASMUserNav user={type} navClick={this.buttonClick} logout={this.props.logout}/>;
			}
		}
		return(
			<div>
				{navbar}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/Nav.js